var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2084_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2319 34V20.95H27.3305L28 15.15H23.2319V12.325C23.2319 10.8315 23.2714 9.35 25.4303 9.35H27.617V5.2032C27.617 5.14085 25.7387 5 23.8385 5C19.87 5 17.3851 7.40293 17.3851 11.8153V15.15H13V20.95H17.3851V34H23.2319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 29,
    fill: "white",
    transform: "translate(13 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIconWhite);
export default __webpack_public_path__ + "static/media/FaceIconWhite.ba161ec2bb6fcaeaeef5169573f73f66.svg";
export { ForwardRef as ReactComponent };